module.exports = __webpack_public_path__ + "static/img/2787_phase_function_Paper_Points.8024591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2787_phase_function_Paper_Points.png
// module id = qOTA
// module chunks = 0